import { Injectable } from '@angular/core';
import { getToken, Messaging, onMessage } from '@angular/fire/messaging';
import { BehaviorSubject, take } from 'rxjs';
import { ProfileDataService } from './profile-data.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private token: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private pushActivated: boolean | null = null;

  constructor(
    private _profile: ProfileDataService,
    private _toast: ToastService,
    private _messaging: Messaging,
  ) {
    onMessage(this._messaging, (msg) => {
      this._toast.add({
        severity: 'info',
        summary: msg.notification?.title,
        detail: msg.notification?.body,
        life: 10000,
      });
    });
  }

  isPushActivated() {
    if (this.pushActivated === null) {
      return null;
    }
    return this.pushActivated;
  }

  async saveMessagingDeviceToken() {
    try {
      const currentToken = await getToken(this._messaging);
      if (currentToken) {
        this.token.next(currentToken);

        const profile = this._profile.getUserProfile();
        if (profile) {
          await this._profile.updateProfile({ push_token: currentToken });
        } else {
          this._profile
            .getUserProfileObservable()
            .pipe(take(1))
            .subscribe(async () => {
              await this._profile.updateProfile({ push_token: currentToken });
            });
        }
        this.pushActivated = true;
        return true;
      }
    } catch (error) {
      console.error('An error occurred while retrieving token. ', error);
    }
    this.pushActivated = false;
    return false;
  }
}